import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ProductTitlePipe } from './product-title.pipe';

/** Components, pipes and directives that are exported by the module */
const PUBLIC_DECLARATIONS = [ProductTitlePipe];
@NgModule({
  imports: [CommonModule],
  declarations: PUBLIC_DECLARATIONS,
  exports: PUBLIC_DECLARATIONS,
})
export class ProductTitleModule {}
